
// planet-ingresses.ui.js
// UI custom: bottone "Ingressi" (toggle) + finestra "Pianeti" (modal light) con toggle persistenti e Strict clear.
// Esporta: initUI(widget, ingressCtrl, options) -> { dispose() }

const PLANET_KEYS = ['SOLE','LUNA','MERCURIO','VENERE','MARTE','GIOVE','SATURNO','URANO','NETTUNO'];
const PLANET_LABEL = {
  SOLE:'Sole', LUNA:'Luna', MERCURIO:'Mercurio', VENERE:'Venere', MARTE:'Marte',
  GIOVE:'Giove', SATURNO:'Saturno', URANO:'Urano', NETTUNO:'Nettuno'
};
const PLANET_ICON = { SOLE:'☉', LUNA:'☽', MERCURIO:'☿', VENERE:'♀', MARTE:'♂', GIOVE:'♃', SATURNO:'♄', URANO:'♅', NETTUNO:'♆' };

// ---------- CSS tema chiaro per modal ----------
function injectModalCss() {
  const css = `
  .tvp-modal-backdrop{
    position: fixed; inset: 0; background: rgba(0,0,0,.35);
    display:flex; align-items:center; justify-content:center; z-index: 99998;
  }
  .tvp-modal{
    background:#fff; color:#222; width:min(720px, 92vw); max-height: 86vh; overflow:auto;
    border:1px solid #E0E0E0; border-radius:10px; box-shadow:0 18px 48px rgba(0,0,0,.20);
    font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  }
  .tvp-modal-header{ display:flex; align-items:center; justify-content:space-between;
    padding:14px 16px; border-bottom:1px solid #ECECEC; }
  .tvp-modal-title{ font-size:16px; font-weight:700; }
  .tvp-close{
    background:transparent; border:none; font-size:20px; line-height:20px; cursor:pointer; color:#666;
  }
  .tvp-modal-body{ padding:12px 16px; }
  .tvp-grid{
    display:grid; grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
    gap:10px; margin-top:8px; margin-bottom:12px;
  }
  .tvp-chip{
    display:flex; align-items:center; gap:8px; padding:10px 12px; border:1px solid #E0E0E0;
    border-radius:8px; cursor:pointer; user-select:none; background:#F7F9FC; color:#222;
    transition: all .15s ease;
  }
  .tvp-chip .tvp-ic{ width:18px; text-align:center; font-size:16px; }
  .tvp-chip .tvp-lb{ flex:1; }
  .tvp-chip .tvp-ck{ width:18px; height:18px; border-radius:4px; border:1px solid #BDBDBD; background:#fff; position:relative; }
  .tvp-chip.active{
    border-color:#1976D2; background:#E8F1FD;
  }
  .tvp-chip.active .tvp-ck{ background:#1976D2; border-color:#1976D2; }
  .tvp-chip.active .tvp-ck::after{
    content:''; position:absolute; left:5px; top:2px; width:4px; height:8px;
    border:2px solid #fff; border-top:0; border-left:0; transform:rotate(45deg);
  }
  .tvp-actions{ display:flex; gap:8px; padding:8px 16px 16px 16px; border-top:1px solid #ECECEC; }
  .tvp-btn{ padding:8px 12px; border-radius:6px; border:1px solid #E0E0E0; background:#F5F7FA; color:#222; cursor:pointer; }
  .tvp-btn:hover{ background:#EEF2F7; }
  .tvp-primary{ background:#1976D2; border-color:#1976D2; color:#fff; }
  .tvp-primary:hover{ background:#165fa8; }
  .tvp-danger{ background:#ffe9e9; border-color:#ffcccc; color:#a30000; }
  .tvp-danger:hover{ background:#ffdcdc; } 
  .tvp-mode { margin-top:8px; padding:8px 0 4px 0; border-top:1px solid #ECECEC; }
  .tvp-mode-title { font-size:12px; font-weight:700; color:#666; margin-bottom:6px; }
  .tvp-radio { display:inline-flex; align-items:center; gap:6px; margin-right:12px; cursor:pointer; user-select:none; }
  .tvp-radio input[type="radio"]{ accent-color:#1976D2; cursor:pointer; }
  `;
  const st = document.createElement('style');
  st.id = 'tvp-modal-css';
  st.textContent = css;
  document.head.appendChild(st);
  return st;
}

// ---------- MODULO UI ----------
export function initUI(widget, ingressCtrl, options = {}) {
  const {
    //planets = [...PLANET_KEYS],               // selezione iniziale con tutti i checks selezionati
    planets = [],       // <-- nessun pianeta selezionato all'apertura
    showStrictClear = true,
    ingressButtonTitle = 'Ingressi',
    planetsButtonTitle = 'Pianeti',
    tooltipToggle = 'Mostra/Nascondi ingressi planetari',
    tooltipPlanets = 'Apri la finestra di selezione pianeti',
    //displayMode = (ingressCtrl.getDisplayMode ? ingressCtrl.getDisplayMode() : 'line+balloon') // <<< NEW: iniziale
    displayMode = (ingressCtrl.getDisplayMode ? ingressCtrl.getDisplayMode() : 'line') // <<< NEW: iniziale
  } = options;

  const state = {
    cssEl: null,
    btnIngressi: null,
    btnPlanets: null,
    backdrop: null,
    modal: null,
    selected: new Set(planets),
    mode: displayMode,         // <<< NEW
    disposed: false,
    escHandler: null,
    outsideHandler: null
  };

  state.cssEl = injectModalCss();

  widget.headerReady().then(() => {
    if (state.disposed) return;

    // --- Bottone "Ingressi" (toggle) ---
    if(ingressButtonTitle && ingressButtonTitle.length>0){
        const btnIng = widget.createButton();
        btnIng.textContent = ingressButtonTitle;
        btnIng.setAttribute('title', tooltipToggle);
        state.btnIngressi = btnIng;
        const setActiveStyle = (on) => {
        btnIng.style.fontWeight = on ? '700' : '400';
        btnIng.style.opacity = on ? '1' : '0.75';
        };
        btnIng.addEventListener('click', async () => {
        if (state.disposed) return;
        await ingressCtrl.toggle();
        setActiveStyle(ingressCtrl.isActive());
        });
        setActiveStyle(false);
    }
    // --- Bottone "Pianeti" (apre finestra) ---
    const btnPl = widget.createButton();
    btnPl.textContent = planetsButtonTitle + ' ▾';
    btnPl.setAttribute('title', tooltipPlanets);
    state.btnPlanets = btnPl;

    btnPl.addEventListener('click', (e) => {
      e.stopPropagation();
      openModal();
    });
  });

  // ---------- finestra (modal) ----------
  const openModal = () => {
    if (state.disposed || state.backdrop) return;

    // Backdrop
    const backdrop = document.createElement('div');
    backdrop.className = 'tvp-modal-backdrop';

    // Modal
    const modal = document.createElement('div');
    modal.className = 'tvp-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-label', 'Selezione pianeti');

    // Header
    const header = document.createElement('div');
    header.className = 'tvp-modal-header';
    const title = document.createElement('div'); title.className = 'tvp-modal-title';
    title.textContent = 'Seleziona gli ingressi da visualizzare';
    const btnClose = document.createElement('button'); btnClose.className = 'tvp-close'; btnClose.innerHTML = '×';
    header.appendChild(title); header.appendChild(btnClose);

    // Body: griglia di "chip" toggle (icone + etichetta + check)
    const body = document.createElement('div'); body.className = 'tvp-modal-body';
    const grid = document.createElement('div'); grid.className = 'tvp-grid';

    const chipByKey = new Map();

    PLANET_KEYS.forEach(key => {
      const chip = document.createElement('div');
      chip.className = 'tvp-chip' + (state.selected.has(key) ? ' active' : '');
      chip.dataset.key = key;

      const ic = document.createElement('span'); ic.className = 'tvp-ic'; ic.textContent = PLANET_ICON[key] || '';
      const lb = document.createElement('span'); lb.className = 'tvp-lb'; lb.textContent = PLANET_LABEL[key] || key;
      const ck = document.createElement('span'); ck.className = 'tvp-ck';

      chip.appendChild(ic); 
      chip.appendChild(lb); 
      chip.appendChild(ck);
      grid.appendChild(chip);
      chipByKey.set(key, chip);
    });

    body.appendChild(grid);

    
    // --- Sezione Modalità ---
    const modeWrap = document.createElement('div');
    modeWrap.className = 'tvp-mode';

    const modeTitle = document.createElement('div');
    modeTitle.className = 'tvp-mode-title';
    modeTitle.textContent = 'Modalità di visualizzazione';

    const optLine = document.createElement('label');
    optLine.className = 'tvp-radio';
    const rLine = document.createElement('input');
    rLine.type = 'radio'; rLine.name = 'tvp-mode'; rLine.value = 'line';
    rLine.checked = (state.mode === 'line');
    optLine.appendChild(rLine);
    optLine.appendChild(document.createTextNode('Solo linea'));

    const optBoth = document.createElement('label');
    optBoth.className = 'tvp-radio';
    const rBoth = document.createElement('input');
    rBoth.type = 'radio'; rBoth.name = 'tvp-mode'; rBoth.value = 'line+balloon';
    rBoth.checked = (state.mode !== 'line'); // default
    optBoth.appendChild(rBoth);
    optBoth.appendChild(document.createTextNode('Linea + balloon'));

    modeWrap.appendChild(modeTitle);
    modeWrap.appendChild(optLine);
    modeWrap.appendChild(optBoth);

    body.appendChild(modeWrap);

    // Footer: azioni
    const footer = document.createElement('div'); footer.className = 'tvp-actions';
    const btnAll = document.createElement('button'); btnAll.className = 'tvp-btn'; btnAll.textContent = 'Seleziona tutti';
    const btnNone = document.createElement('button'); btnNone.className = 'tvp-btn'; btnNone.textContent = 'Nessuno'; btnNone.id='btnNone';
    const btnClose2 = document.createElement('button'); btnClose2.className = 'tvp-btn'; btnClose2.textContent = 'Chiudi';
    const btnApply = document.createElement('button'); btnApply.className = 'tvp-btn tvp-primary'; btnApply.textContent = 'Applica'; btnApply.id='btnApply';

    footer.appendChild(btnAll); 
    footer.appendChild(btnNone);

    if (showStrictClear) {
      const btnStrict = document.createElement('button'); btnStrict.className = 'tvp-btn tvp-danger';
      btnStrict.textContent = '⚠ Rimuovi tutto';
      btnStrict.addEventListener('click', async () => {
        try {
          /*
          // Spegni il controller (se attivo) e rimuovi TUTTE le shapes
          if (ingressCtrl?.isActive?.()) await ingressCtrl.hide();
          widget.activeChart().removeAllShapes(); // ⚠️ rimuove anche disegni utente
          */
          $("#btnNone").click(); // deseleziona tutti i check-boxes
          $("#btnApply").click(); // preme apply
          
        } finally {
          closeModal();
        }
      });
      footer.appendChild(btnStrict);
    }

    footer.appendChild(btnClose2);
    footer.appendChild(btnApply);

    // Monta modal
    modal.appendChild(header);
    modal.appendChild(body);
    modal.appendChild(footer);
    backdrop.appendChild(modal);
    document.body.appendChild(backdrop);

    state.backdrop = backdrop;
    state.modal = modal;

    // --- Interazioni ---
    const toggleKey = (key) => {
      const chip = chipByKey.get(key);
      if (!chip) return;
      const on = chip.classList.toggle('active');
      if (on) state.selected.add(key); else state.selected.delete(key);
    };

    grid.addEventListener('click', (e) => {
      const chip = e.target.closest('.tvp-chip');
      if (chip && chip.dataset.key) toggleKey(chip.dataset.key);
    });

    btnAll.addEventListener('click', () => {
      PLANET_KEYS.forEach(k => { state.selected.add(k); chipByKey.get(k)?.classList.add('active'); });
    });

    btnNone.addEventListener('click', () => {
      state.selected.clear();
      PLANET_KEYS.forEach(k => chipByKey.get(k)?.classList.remove('active'));
    });

    
    modeWrap.addEventListener('change', (e) => {
    if (e.target?.name === 'tvp-mode') {
        state.mode = e.target.value === 'line' ? 'line' : 'line+balloon';
    }
    });

    // Applica = chiama setPlanets e chiudi
    btnApply.addEventListener('click', async () => {
        
        // 1) aggiorna modalità
        if (ingressCtrl.setDisplayMode) {
            await ingressCtrl.setDisplayMode(state.mode);
        }
        // 2) aggiorna pianeti
        await ingressCtrl.setPlanets([...state.selected]);

        // 3) se il controller è spento, disegna ora
        if (!ingressCtrl.isActive || !ingressCtrl.isActive()) {
            await ingressCtrl.show();
        } else {
            // se è già acceso, setPlanets ha già forzato il render
            // (grazie alla Patch 1)
        }

        closeModal();

        // aggiorna il testo del bottone in toolbar con il conteggio
        if (state.btnPlanets) {
            const total = PLANET_KEYS.length;
            const n = state.selected.size;
            state.btnPlanets.textContent = (n===total) ? (planetsButtonTitle + ' ▾') : (`${planetsButtonTitle} (${n}) ▾`);
        }
    });


    // Chiudi
    const doClose = () => closeModal();
    btnClose.addEventListener('click', doClose);
    btnClose2.addEventListener('click', doClose);

    // Chiudi con ESC
    state.escHandler = (ev) => { if (ev.key === 'Escape') closeModal(); };
    document.addEventListener('keydown', state.escHandler, true);

    // Click fuori (sulla backdrop)
    state.outsideHandler = (ev) => { if (ev.target === backdrop) closeModal(); };
    backdrop.addEventListener('click', state.outsideHandler);
  };

  const closeModal = () => {
    if (!state.backdrop) return;
    // cleanup handlers modal
    if (state.escHandler) { document.removeEventListener('keydown', state.escHandler, true); state.escHandler = null; }
    if (state.outsideHandler) { state.backdrop.removeEventListener('click', state.outsideHandler); state.outsideHandler = null; }
    // remove DOM
    try { state.backdrop.remove(); } catch {}
    state.backdrop = null;
    state.modal = null;
  };

  // ---------- cleanup ----------
  function dispose() {
    if (state.disposed) return;
    state.disposed = true;

    // chiudi modal se aperta
    closeModal();

    // rimuovi bottoni toolbar
    try { state.btnIngressi?.remove(); } catch {}
    try { state.btnPlanets?.remove(); } catch {}

    // rimuovi CSS
    try { state.cssEl?.remove(); } catch {}
  }

  return { dispose };
}
